<template>
	<div class="map-mini">
		<div class="map-wrapper">
			<div id="trafficMap" class="map-container" v-bind:class="{ show: mode == 'traffic' }">
			</div>
			<div id="weatherMap" class="map-container" v-bind:class="{ show: mode == 'weather' }">
			</div>
		</div>
	</div>
</template>

<script>
	//let updateInterval = 10; // in seconds
	let trafficMap = null;
	let weatherMap = null;
	let tileBaseUrl = "https://mesonet.agron.iastate.edu/cache/tile.py/1.0.0/nexrad-n0q-900913";
	let radarLoop = null;
	let trafficIndex = 0;
	let weatherIndex = 0;
	let refreshInterval = null;
	let trafficMapDiv = null;
	let weatherMapDiv = null;

	const TARGET_CENTER = { lat: 43.061533, lng: -89.386699 };
	const DISTANT_CENTER = { lat: 0, lng: 0 }; // Coordinates near Africa/Atlantic (far away from WI)

	export default {
		name: 'MiniMap',

		data() {
			return {
				mode: null
			}
		},

		mounted() {
			console.log("Map mini module initiated");
			this.mode = "traffic"
			trafficMap = null;
			weatherMap = null;
			trafficMapDiv = document.getElementById('trafficMap');
			weatherMapDiv = document.getElementById('weatherMap');
			trafficMapDiv.innerHTML = "";
			weatherMapDiv.innerHTML = "";
			this.getTrafficMap();
			this.getWeatherMap();
			refreshInterval = setInterval(this.toggleMap, 1000 * 10);
		},

		destroyed() {
			console.log("Stopping Map mini module");
			clearInterval(refreshInterval);
			clearInterval(radarLoop);
			trafficMap = null;
			weatherMap = null;
		},

		methods: {
			toggleMap() {
				const self = this;
				trafficIndex++;
				weatherIndex++;
				if (trafficIndex >= 18 && self.mode === "weather") {
					trafficIndex = 0;
					console.log("Traffic refresh");
					const currentZoom = trafficMap.getZoom();
					trafficMap.setCenter(DISTANT_CENTER);
					setTimeout(function () {
						trafficMap.setCenter(TARGET_CENTER);

						setTimeout(function () {
							self.mode = "traffic";
						}, 500);
					}, 500);
				} else if (weatherIndex >= 30 && self.mode === "traffic") {
					console.log("Weather loop refresh");
					weatherIndex = 0;
					this.updateRadarLoop();
					self.mode = "weather";
				} else {
					self.mode = self.mode === "traffic" ? "weather" : "traffic";
				}
			},

			getTrafficMap() {
				trafficMap = new google.maps.Map(trafficMapDiv, {
					zoom: 11,
					gestureHandling: "none",
					streetViewControl: false,
					draggable: false,
					zoomControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					center: TARGET_CENTER,
					disableDefaultUI: true,
					keyboardShortcuts: false
				});

				const trafficLayer = new google.maps.TrafficLayer();
				trafficLayer.setMap(trafficMap);
			},

			getWeatherMap() {
				weatherMap = new google.maps.Map(weatherMapDiv, {
					zoom: 8,
					maxZoom: 8,
					minZoom: 8,
					gestureHandling: "none",
					streetViewControl: false,
					zoomControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					center: { lat: 43.061533, lng: -89.386699 },
					disableDefaultUI: true,
					keyboardShortcuts: false
				});
				this.initRadarLoop();
			},

			updateTraffic(trafficLayer, on) {
				if (on == 0) {
					trafficLayer.setMap(null);
					trafficLayer = null;
					setTimeout(function () { updateTraffic(null, 1) }, 1)
				}
				if (on == 1) {
					var trafficLayer2 = new google.maps.TrafficLayer();
					trafficLayer2.setMap(trafficMap);
					// after 300ms (or 5 minutes) update the traffic map
					setTimeout(function () { updateTrafficOnMap(trafficLayer2, 0) }, 300000)
				}
			},

			updateRadar() {
				let tileNEX = new google.maps.ImageMapType({
					getTileUrl: function(tile, zoom) {
						return tileBaseUrl + "/" + zoom + "/" + tile.x + "/" + tile.y +".png?"+ (new Date()).getTime(); 
					},
					tileSize: new google.maps.Size(256, 256),
					opacity:0.60,
					name : 'NEXRAD',
					isPng: true
				});

				weatherMap.overlayMapTypes.push(null); // create empty overlay entry
				weatherMap.overlayMapTypes.setAt("0",tileNEX);
			},

			initRadarLoop() {
				for (var i = 0; i < 6; i++) weatherMap.overlayMapTypes.push(null);
				this.updateRadarLoop();
				this.animateRadar();
			},

			updateRadarLoop() {
				let radarImages = {
					"NEXRAD": "",
					"NEXRAD5": "-m05m",
					"NEXRAD10": "-m10m",
					"NEXRAD15": "-m15m",
					"NEXRAD20": "-m20m",
					"NEXRAD25": "-m25m",
					"NEXRAD30": "-m30m",
				}

				let index = 0;
				for (var i in radarImages) {
					let tileUrl  = tileBaseUrl + radarImages[i];
					let tile = new google.maps.ImageMapType({
						getTileUrl: function(tile, zoom) {
							return tileUrl + "/" + zoom + "/" + tile.x + "/" + tile.y +".png?"+ (new Date()).getTime();
						},
						tileSize: new google.maps.Size(256, 256),
						opacity: 0,
						name: i,
						isPng: true,
					});
					weatherMap.overlayMapTypes.setAt(index, tile);
					index++;
				}
			},

			animateRadar() {
				const self = this;
				let maxIndex = weatherMap.overlayMapTypes.getLength() - 1;
				let index = maxIndex;
				radarLoop = setInterval(function(){
					if (index <= 0) {
						clearInterval(radarLoop);
						setTimeout(self.animateRadar, 1000);
					} else {
						if (index === maxIndex) weatherMap.overlayMapTypes.getAt(0).setOpacity(0);
						else weatherMap.overlayMapTypes.getAt(index).setOpacity(0);
						index--;
						weatherMap.overlayMapTypes.getAt(index).setOpacity(0.60);
					}
				}, 400);
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	@bg-map: #E5E3DF;

	.map-mini {
		height: 65%;

		.map-wrapper {
			border-radius: @border-radius;
			background-color: @bg-map;
			height: 100%;
			position: relative;
		}

		.map-container {
			border-radius: @border-radius;
			height: 100%;
			left: 0;
			top: 0;
			bottom: 0;
			right: 0;
			position: absolute;
			opacity: 0;
			//transition: opacity 0.5s ease-in-out;

			&.show {
				opacity: 1;
			}
		}
	}

</style>


// WEBPACK FOOTER //
// map-mini.vue?d73334ba